<template>
  <ListingCard
    :title="item.name"
    :description="item.description"
    :show-actions-star="false"
    :show-actions-trash="true"
    :show-actions-edit="true"
    actions-star-title="Unavailable"
    :actions-trash-title="deleteConfigurationTitle"
    :actions-edit-title="editConfigurationTitle"
    :actions-star-disabled="true"
    :actions-trash-disabled="false"
    :actions-edit-disabled="false"
    @onCardClicked="handleOnCardClicked"
    @onActionsStarClicked="addItemToFavourites"
    @onActionsTrashClicked="deleteItem"
    @onActionsEditClicked="editItem"
    class="plan-listing-item-card-container"
  >
    <div class="date-container" slot="subtitle">
      <span>{{ itemStartDateString }}</span>
      <i class="fas fa-chevron-right date-spacer"></i>
      <span>{{ itemEndDateString }}</span>
    </div>

    <div class="item-changelog-details-container" slot="additionalDetails">
      <div class="changelog-details-item created-date">
        <h6>
          <Localization message="listing-created-on" />
        </h6>
        <p>{{ itemCreatedDateString }}</p>
      </div>

      <div class="changelog-details-item created-user">
        <h6>
          <Localization message="listing-action-by" />
        </h6>
        <p>{{ item.createdByUserName }}</p>
      </div>

      <div class="changelog-details-item updated-date">
        <h6>
          <Localization message="listing-last-update" />
        </h6>
        <p>{{ itemUpdatedDateString }}</p>
      </div>

      <div class="changelog-details-item updated-user">
        <h6>
          <Localization message="listing-action-by" />
        </h6>
        <p>{{ item.updatedByUserName }}</p>
      </div>
    </div>
  </ListingCard>
</template>

<script>
import {
  ListingCard,
  Localization,
  Translator,
} from "@agyletime/wfm-vue-common";
import { formatDateByStringInTz } from "@agyletime/date-utils";

const formatStrings = {
  dateOnly: "dd MMM yyyy",
  dateAndTime: "dd MMM yyyy HH:mm",
};

export default {
  name: "PlanListingItem",
  components: { ListingCard, Localization },
  mixins: [Translator],
  props: ["item", "onTitleClicked"],
  computed: {
    itemStartDateString() {
      const utcDate = new Date(this.item && this.item.startDate);
      return formatDateByStringInTz({
        utcDate,
        formatString: formatStrings.dateOnly,
      });
    },
    itemEndDateString() {
      const utcDate = new Date(this.item && this.item.endDate);
      return formatDateByStringInTz({
        utcDate,
        formatString: formatStrings.dateOnly,
      });
    },
    itemCreatedDateString() {
      const utcDate = new Date(this.item && this.item.createdAt);
      return formatDateByStringInTz({
        utcDate,
        formatString: formatStrings.dateOnly,
      });
    },
    itemUpdatedDateString() {
      const utcDate = new Date(this.item && this.item.updatedAt);
      return formatDateByStringInTz({
        utcDate,
        formatString: formatStrings.dateAndTime,
      });
    },
    deleteConfigurationTitle() {
      return this.translate("listing-delete-plan");
    },
    editConfigurationTitle() {
      return this.translate("listing-edit-plan");
    },
  },
  methods: {
    addItemToFavourites() {},
    deleteItem() {
      this.$emit("onDeleteItem", { configuration: this.item });
    },
    handleOnCardClicked() {
      this.$emit("onListingItemClicked", { configuration: this.item });
    },
    editItem() {
      this.$emit("onEditItem", { configuration: this.item });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.plan-listing-item-card-container {
  margin-bottom: 1.5rem;
}

.date-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1em;
}

.date-spacer {
  margin: 0 1rem;
  font-size: 0.5rem;
  padding-bottom: 2px; // Vertical alignment
}

// Changelog Details Item (Right side)
.item-changelog-details-container {
  display: grid;
  grid-gap: 1rem;
  grid-template-areas:
    "created-date created-user"
    "updated-date updated-user";
}

.changelog-details-item {
  & h6,
  & p {
    font-size: 12px;
    margin: 0;
  }

  & h6 {
    margin: 0 0 4px 0;
    color: var(--color-eerie-black-50);
    font-weight: 400;
  }

  & p {
    text-overflow: ellipsis;
    line-height: 1em;
  }

  &.created-date {
    grid-area: created-date;
  }

  &.created-user {
    grid-area: created-user;
    width: 120px;
  }

  &.updated-date {
    grid-area: updated-date;
  }

  &.updated-user {
    grid-area: updated-user;
    width: 120px;
  }
}
</style>
